import { IPartnerShipLA } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormComponents/partnerShip/hooks/usePartnerShipLA'
import { IPartnerShipNA } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormComponents/partnerShip/types'

import { onboardingPartnershipApi } from 'onboarding/api/OnboardingPartnershipApi'

class PartnershipService {
  public getLAByRequestId(requestId: number, force: boolean) {
    return onboardingPartnershipApi.getLAByRequestId(requestId, force)
  }

  public createLA(data: Partial<IPartnerShipLA>[]) {
    return onboardingPartnershipApi.createLA(data)
  }

  public updateLA(data: Partial<IPartnerShipLA>[]) {
    return onboardingPartnershipApi.updateLA(data)
  }

  public saveNA(payload: IPartnerShipNA, appOwnerId: string) {
    return onboardingPartnershipApi.saveNA(payload, appOwnerId)
  }

  public getNAByRequestId(requestId: number, appOwnerId: string) {
    return onboardingPartnershipApi.getNAByRequestId(requestId, appOwnerId)
  }
}

export const partnershipService = new PartnershipService()
